var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { message } from 'antd';
import certificateService from '../services/certificateService';
import dayjs from 'dayjs';
import { setWoBrandNames, setBrandNamesCertProjects, setBrandNamesWithIAProjects, setCertIAUploadProjectBrandNames, setBrandNames, setClientProductlst, setWoCountry, setWoModelNames, setCountryCertProjects, setBvCertLocations, setBvLocations, setCertExpInSixMonthCount, setCertRenewalReminderCount, setFactoryAuditNotifyCount, setLastTwoMonthUpdRegCount, setModelNames, setModelNamesWithIAProjects, setReqUpdLastTwoMonthCount } from '../context/reducers/userReducer';
import commonService from '../services/CommonService';
import { sha256 } from 'js-sha256';
import * as CryptoJS from 'crypto-js';
export function convertSelFilterValToLuObj(selFilterValArr) {
    return selFilterValArr.map((id) => ({ intId: typeof id === 'string' ? parseInt(id) : id }));
}
export function convertLuObjToSelFilterVal(selFilterValArr) {
    return selFilterValArr.map((item) => (item === null || item === void 0 ? void 0 : item.intId) + '');
}
export function convertSelFilterValBusinessToLuObj(selFilterValArr) {
    return selFilterValArr.map((id) => ({ intBusinessUnitId: typeof id === 'string' ? parseInt(id) : id }));
}
export function convertSelFilterValToLuObjUser(selFilterValArr) {
    return selFilterValArr.map((id) => ({
        objUser: {
            intId: typeof id === 'string' ? parseInt(id) : id
        }
    }));
}
export function convertDataToSelectOptions(jsonData) {
    const options = [];
    if (jsonData) {
        for (const obj of jsonData) {
            options.push({
                label: obj === null || obj === void 0 ? void 0 : obj.strLongDesc,
                value: obj.intId
            });
        }
    }
    return options;
}
export function convertDataToSelectOptionsBVlocations(jsonData) {
    const options = [];
    if (jsonData) {
        for (const obj of jsonData) {
            options.push({
                label: obj === null || obj === void 0 ? void 0 : obj.strBusinessUnitName,
                value: obj.intBusinessUnitId
            });
        }
    }
    return options;
}
export function convertCompanyDataToSelectOptions(jsonData) {
    const options = [];
    if (jsonData) {
        for (const obj of jsonData) {
            options.push({
                label: obj === null || obj === void 0 ? void 0 : obj.companyName,
                value: obj.companyId
            });
        }
    }
    return options;
}
export const formatDate = (dateStr) => {
    if (dateStr == null || dateStr == undefined) {
        return null;
    }
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    return formattedDate;
};
export const formatDateDisplay = (date) => {
    const formattedDate = date === null || date === undefined
        ? null
        : dayjs(date, 'DD/MM/YYYY hh:mm:ss').format('DD-MMM-YYYY');
    return formattedDate;
};
export function convertSelProjectType(no) {
    if (no.length === 0 || no.length === 2) {
        return null;
    }
    else if (no[0] == 1 || no[1] == 1) {
        return false;
    }
    else {
        return true;
    }
}
export const formatDisplayDate = (date) => {
    const formattedDate = (date == null || date == undefined) ? null : dayjs(date, "DD-MM-YYYY hh:mm:ss").format('DD-MMM-YYYY');
    return formattedDate;
};
export const formatDateForExcel = (dateString) => {
    if (dateString === null || dateString === undefined)
        return null;
    // Split the input string into date and time parts
    const [datePart, timePart] = dateString.split(" ");
    // Split the date part into day, month, and year
    var [day, month, year] = datePart.split("/");
    // Create a new date string in "MM/DD/YYYY" format
    return `${month}/${day}/${year}`;
};
export const isEmptyObject = (object) => {
    return JSON.stringify(object) === '{}';
};
// export const DownloadDocument = (strDocRefId: String | undefined): void => {
//   certificateService.getFileDocument(strDocRefId).then((res) => {
//     if(res?.bytefileData){
//     let typeOfFile;
//     if (res?.strDocName?.includes('.pdf')) {
//       typeOfFile = { type: 'application/pdf' };
//     } else {
//       typeOfFile = { type: 'application/*' };
//     }
//     //Convert the bytefileData to a Blob
//     const blob = new Blob([new Uint8Array(res?.bytefileData)], typeOfFile);
//     // Create a download link for the Blob
//     const downloadUrl = URL.createObjectURL(blob);
//     if (res?.strDocName?.includes('.zip')) {
//       let a = document.createElement('a');
//       a.href = downloadUrl;
//       a.download = res?.strDocName;
//       a.click();
//     } else if (res?.strDocName?.includes('.pdf')) {
//       window.open(downloadUrl);
//     }
//   }else{
//     message.error('No documents Available to download');
//   }
//   });
// };
export const fetchClientRelatedData = (selClientList, dispatch) => {
    if (selClientList && selClientList.length) {
        commonService.getModelNames(selClientList).then((res) => {
            dispatch(setModelNames(res));
        });
        // commonService.getServiceCode(selClientList).then((res: LuService[]) => {
        //     dispatch(setServiceCode(res));
        // });
        commonService.getModelNamesWithIAProjects(selClientList).then((res) => {
            dispatch(setModelNamesWithIAProjects(res));
        });
        commonService.getAllNotificationsCount(selClientList, 'getAllFANotificationsCount').then((res) => {
            dispatch(setFactoryAuditNotifyCount(res));
        });
        commonService.getAllNotificationsCount(selClientList, 'getCertExpInSixMonthCount').then((res) => {
            dispatch(setCertExpInSixMonthCount(res));
        });
        commonService.getAllNotificationsCount(selClientList, 'getCertRenewalReminderCount').then((res) => dispatch(setCertRenewalReminderCount(res)));
        commonService.getAllNotificationsCount(selClientList, 'getLastTwoMonthUpdRegCount').then((res) => dispatch(setLastTwoMonthUpdRegCount(res)));
        commonService.getAllNotificationsCount(selClientList, 'getReqUpdLastTwoMonthCount').then((res) => dispatch(setReqUpdLastTwoMonthCount(res)));
        commonService.getBVLocationList(selClientList).then((res) => {
            dispatch(setBvLocations(res));
        });
        commonService.getBVLocationCertList(selClientList).then((res) => {
            dispatch(setBvCertLocations(res));
        });
        commonService.getCountryCertProjects(selClientList).then((res) => {
            dispatch(setCountryCertProjects(res));
        });
        commonService.getWoModelNames(selClientList).then((res) => {
            dispatch(setWoModelNames(res));
        });
        commonService.getWoCountry(selClientList).then((res) => {
            dispatch(setWoCountry(res));
        });
        commonService.getClientProductlst(selClientList).then((res) => {
            dispatch(setClientProductlst(res));
        });
        commonService.getBrandNames(selClientList).then((res) => {
            dispatch(setBrandNames(res));
        });
        commonService.getIACertUploadProjectBrandNames(selClientList).then((res) => {
            dispatch(setCertIAUploadProjectBrandNames(res));
        });
        commonService.getBrandNamesWithIAProjects(selClientList).then((res) => {
            dispatch(setBrandNamesWithIAProjects(res));
        });
        commonService.getBrandNamesCertProjects(selClientList).then((res) => {
            dispatch(setBrandNamesCertProjects(res));
        });
        commonService.getWoBrandNames(selClientList).then((res) => {
            dispatch(setWoBrandNames(res));
        });
    }
};
export function multiSelectObj(title, selList, setSelList, jsonData) {
    return {
        multiSelect: {
            data: convertDataToSelectOptions(jsonData),
            title: title,
            value: selList,
            setValue: setSelList
        }
    };
}
export function dateRangeObj(title, selIssueDateRange, setSelIssueDateRange) {
    return {
        dateRange: {
            title: title,
            value: selIssueDateRange,
            setValue: setSelIssueDateRange
        }
    };
}
export const decodeBase64 = (str) => {
    try {
        return atob(str);
    }
    catch (e) {
        console.error('Failed to decode base64 string:', e);
        return '';
    }
};
export function getCountryCombination(res, objFlagArr, objAccess) {
    var _a, _b, _c, _d, _e, _f;
    if (objFlagArr)
        try {
            for (const assc of objFlagArr) {
                if (((assc === null || assc === void 0 ? void 0 : assc.intCountryId) !== null &&
                    ((_a = res === null || res === void 0 ? void 0 : res.objLuCountry) === null || _a === void 0 ? void 0 : _a.intId) !== null &&
                    (assc === null || assc === void 0 ? void 0 : assc.intCountryId) === ((_b = res === null || res === void 0 ? void 0 : res.objLuCountry) === null || _b === void 0 ? void 0 : _b.intId)) ||
                    (objAccess === null || objAccess === void 0 ? void 0 : objAccess.boolIsAllCountrys)) {
                    if (((assc === null || assc === void 0 ? void 0 : assc.intServiceId) !== null &&
                        ((_c = res === null || res === void 0 ? void 0 : res.objLuServiceCode) === null || _c === void 0 ? void 0 : _c.intId) !== null &&
                        (assc === null || assc === void 0 ? void 0 : assc.intServiceId) === ((_d = res === null || res === void 0 ? void 0 : res.objLuServiceCode) === null || _d === void 0 ? void 0 : _d.intId)) ||
                        (objAccess === null || objAccess === void 0 ? void 0 : objAccess.boolIsAllServiceTypes)) {
                        if (((assc === null || assc === void 0 ? void 0 : assc.intProductId) !== null &&
                            ((_e = res === null || res === void 0 ? void 0 : res.objLuProductType) === null || _e === void 0 ? void 0 : _e.intId) !== null &&
                            (assc === null || assc === void 0 ? void 0 : assc.intProductId) === ((_f = res === null || res === void 0 ? void 0 : res.objLuProductType) === null || _f === void 0 ? void 0 : _f.intId)) ||
                            (objAccess === null || objAccess === void 0 ? void 0 : objAccess.boolIsAllProductTypes)) {
                            res.boolIsCountryCombination = true;
                        }
                    }
                }
            }
        }
        catch (e) { }
    return res;
}
export function getClientList(applicationData) {
    if (applicationData === null || applicationData === void 0 ? void 0 : applicationData.selClientList) {
        let lstObjLuCompany = [];
        applicationData.selClientList.map((data) => {
            lstObjLuCompany.push({
                objLuCompany: data,
            });
        });
        return lstObjLuCompany;
    }
}
export function shaEncryptPass(pass) {
    try {
        return sha256(pass);
    }
    catch (error) {
        throw error;
    }
}
export function getEncryptPass() {
    return shaEncryptPass('admin') + ':' + shaEncryptPass('!#Dasd@!3AS$!23)(*SA#12SXR3#!C$%^SoYRer');
    ;
}
function formatNotiDate(date) {
    return date.toISOString().split('T')[0].split('-').reverse().join('/');
}
export function getDateRanges() {
    const today = new Date();
    const expiringToday = formatNotiDate(today);
    // Next 30 Days
    // const next30DaysStart = new Date(today);
    // const next30DaysEnd = new Date(today);
    // next30DaysEnd.setDate(next30DaysEnd.getDate() + 30);
    // const next30Days = `${formatNotiDate(next30DaysStart)} - ${formatNotiDate(next30DaysEnd)}`;
    const next30DaysStart = new Date(today);
    next30DaysStart.setDate(next30DaysStart.getDate() + 1); // Start from tomorrow
    const next30DaysEnd = new Date(next30DaysStart);
    next30DaysEnd.setDate(next30DaysEnd.getDate() + 29); // 30 days range from tomorrow
    const next30Days = `${formatNotiDate(next30DaysStart)} - ${formatNotiDate(next30DaysEnd)}`;
    // This Week
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay() + 1); // Assuming the week starts on Monday
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    const thisWeek = `${formatNotiDate(startOfWeek)} - ${formatNotiDate(endOfWeek)}`;
    // Expired Last Week
    const startOfLastWeek = new Date(startOfWeek);
    startOfLastWeek.setDate(startOfWeek.getDate() - 7);
    const endOfLastWeek = new Date(endOfWeek);
    endOfLastWeek.setDate(endOfWeek.getDate() - 7);
    const lastWeek = `${formatNotiDate(startOfLastWeek)} - ${formatNotiDate(endOfLastWeek)}`;
    // Expired Two Weeks Ago
    const startOfTwoWeeksAgo = new Date(startOfLastWeek);
    startOfTwoWeeksAgo.setDate(startOfLastWeek.getDate() - 7);
    const endOfTwoWeeksAgo = new Date(endOfLastWeek);
    endOfTwoWeeksAgo.setDate(endOfLastWeek.getDate() - 7);
    const twoWeeksAgo = `${formatNotiDate(startOfTwoWeeksAgo)} - ${formatNotiDate(endOfTwoWeeksAgo)}`;
    // Expired Three Weeks Ago
    const startOfThreeWeeksAgo = new Date(startOfTwoWeeksAgo);
    startOfThreeWeeksAgo.setDate(startOfTwoWeeksAgo.getDate() - 7);
    const endOfThreeWeeksAgo = new Date(endOfTwoWeeksAgo);
    endOfThreeWeeksAgo.setDate(endOfTwoWeeksAgo.getDate() - 7);
    const threeWeeksAgo = `${formatNotiDate(startOfThreeWeeksAgo)} - ${formatNotiDate(endOfThreeWeeksAgo)}`;
    return {
        expiringToday,
        next30Days,
        thisWeek,
        lastWeek,
        twoWeeksAgo,
        threeWeeksAgo
    };
}
export function decryptURL(encryptedUrl) {
    const key = CryptoJS.enc.Utf8.parse("3B68B3ADF1613223"); // 16 bytes key required
    const standardBase64 = encryptedUrl.replace(/-/g, '+').replace(/_/g, '/');
    const decrypted = CryptoJS.AES.decrypt(standardBase64, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}
import Cookies from 'js-cookie';
export function getLocalAccessToken() {
    return __awaiter(this, void 0, void 0, function* () {
        return Cookies.get('accessToken');
    });
}
export function getLocalRefreshToken() {
    return __awaiter(this, void 0, void 0, function* () {
        return Cookies.get('refreshToken');
    });
}
export function clearTokenLogout() {
    return __awaiter(this, void 0, void 0, function* () {
        commonService.signout({ refreshToken: yield getLocalRefreshToken() }).catch((error) => {
            console.error('Error during signout:', error);
        }).finally(() => {
            Cookies.remove('accessToken');
            Cookies.remove('refreshToken');
        });
    });
}
export const DownloadDocument = (strDocRefId) => {
    certificateService.getFileDocument(strDocRefId).then((res) => {
        if (!(res === null || res === void 0 ? void 0 : res.bytefileData)) {
            message.error('No documents available to download');
            return;
        }
        const { strDocName, bytefileData } = res;
        const isPdf = strDocName === null || strDocName === void 0 ? void 0 : strDocName.endsWith('.pdf');
        const isZip = strDocName === null || strDocName === void 0 ? void 0 : strDocName.endsWith('.zip');
        // Determine the MIME type
        const mimeType = isPdf ? 'application/pdf' : 'application/octet-stream';
        // Convert the bytefileData to a Blob
        const blob = new Blob([new Uint8Array(bytefileData)], { type: mimeType });
        const downloadUrl = URL.createObjectURL(blob);
        if (isZip) {
            const anchor = document.createElement('a');
            anchor.href = downloadUrl;
            anchor.download = strDocName || 'download.zip';
            anchor.click();
        }
        else if (isPdf) {
            window.open(downloadUrl);
        }
        else {
            const anchor = document.createElement('a');
            anchor.href = downloadUrl;
            anchor.download = strDocName || 'download';
            anchor.click();
        }
        // Cleanup the object URL
        URL.revokeObjectURL(downloadUrl);
    });
};
